var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6461 2.02311C6.16395 1.63603 1.63597 6.16401 2.02305 11.6462C2.34712 16.4082 6.50602 20 11.2771 20H14.5988C15.0939 20 15.499 19.5949 15.499 19.0998C15.499 18.6047 15.0939 18.1996 14.5988 18.1996H11.2951C7.93733 18.1996 4.85866 16.0211 4.02148 12.7714C2.68019 7.55031 7.54124 2.68025 12.7624 4.03055C16.0211 4.85872 18.1995 7.93739 18.1995 11.2951V12.2853C18.1995 12.9965 17.5604 13.6986 16.8493 13.6986C16.1381 13.6986 15.499 12.9965 15.499 12.2853V11.1601C15.499 8.9006 13.8966 6.86616 11.6641 6.55109C8.60347 6.11 6.01991 8.75657 6.56903 11.8352C6.8751 13.5546 8.21639 14.9769 9.91776 15.382C11.5741 15.7691 13.1495 15.238 14.1847 14.1847C14.9859 15.283 16.5882 15.8591 18.0555 15.274C19.2618 14.7969 19.9999 13.5636 19.9999 12.2673V11.2861C19.9999 6.50608 16.4082 2.34718 11.6461 2.02311ZM10.998 13.6986C9.50367 13.6986 8.29741 12.4924 8.29741 10.9981C8.29741 9.50373 9.50367 8.29747 10.998 8.29747C12.4923 8.29747 13.6986 9.50373 13.6986 10.9981C13.6986 12.4924 12.4923 13.6986 10.998 13.6986Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/EmailIcon.254a9344804b126deb0ba9080f81b4d6.svg";
export { ForwardRef as ReactComponent };